var MARGIN = 8;
export var menuDefaultPositionSetter = function (_a) {
    var triggerDimensions = _a.triggerDimensions, menuHeight = _a.menuHeight, menuWidth = _a.menuWidth, position = _a.position;
    var _b = document.documentElement, clientHeight = _b.clientHeight, clientWidth = _b.clientWidth;
    var bottom;
    var left;
    var right;
    var top;
    switch (position) {
        case 'horizontal': {
            var rightOfTrigger = triggerDimensions.right + MARGIN;
            var spaceAtRightOfTrigger = clientWidth - rightOfTrigger - MARGIN;
            if (menuWidth > spaceAtRightOfTrigger) {
                var leftOfTrigger = triggerDimensions.left - MARGIN;
                var spaceAtLeftOfTrigger = leftOfTrigger - MARGIN;
                if (menuWidth > spaceAtLeftOfTrigger) {
                    // Place the menu where there is more room and constrains its width.
                    if (spaceAtLeftOfTrigger > spaceAtRightOfTrigger) {
                        left = MARGIN;
                        right = clientWidth - leftOfTrigger;
                    }
                    else {
                        left = rightOfTrigger;
                        right = MARGIN;
                    }
                }
                else {
                    right = clientWidth - leftOfTrigger;
                }
            }
            else {
                left = rightOfTrigger;
            }
            if (menuHeight + 2 * MARGIN > clientHeight) {
                bottom = MARGIN;
                top = MARGIN;
            }
            else {
                var spaceFromTopOfTrigger = clientHeight - triggerDimensions.top - MARGIN;
                if (menuHeight > spaceFromTopOfTrigger) {
                    var spaceToBottomOfTrigger = triggerDimensions.bottom - MARGIN;
                    if (menuHeight > spaceToBottomOfTrigger) {
                        if (spaceToBottomOfTrigger > spaceFromTopOfTrigger) {
                            top = MARGIN;
                        }
                        else {
                            bottom = MARGIN;
                        }
                    }
                    else {
                        bottom = clientHeight - triggerDimensions.bottom;
                    }
                }
                else {
                    top = triggerDimensions.top;
                }
            }
            return { top: top, right: right, bottom: bottom, left: left };
        }
        case 'centered':
        case 'vertical':
        case 'vertical-centered':
        case 'vertical-stretched': {
            var minWidth = void 0;
            var bottomOfTrigger = triggerDimensions.bottom + MARGIN;
            var spaceBelowTrigger = clientHeight - bottomOfTrigger - MARGIN;
            if (menuHeight > spaceBelowTrigger) {
                var topOfTrigger = triggerDimensions.top - MARGIN;
                var spaceAboveTrigger = topOfTrigger - MARGIN;
                if (menuHeight > spaceAboveTrigger) {
                    // Place the menu where there is more room and constrains its height.
                    if (spaceAboveTrigger > spaceBelowTrigger) {
                        bottom = clientHeight - topOfTrigger;
                        top = MARGIN;
                    }
                    else {
                        bottom = MARGIN;
                        top = bottomOfTrigger;
                    }
                }
                else {
                    bottom = clientHeight - topOfTrigger;
                }
            }
            else {
                top = bottomOfTrigger;
            }
            if (menuWidth + 2 * MARGIN > clientWidth) {
                left = MARGIN;
                right = MARGIN;
            }
            else if (position === 'centered' || position === 'vertical-centered') {
                var menuCenterOffset = (menuWidth - triggerDimensions.width) / 2;
                var spaceAtRightOfTrigger = clientWidth - triggerDimensions.right - MARGIN;
                if (menuCenterOffset > spaceAtRightOfTrigger) {
                    right = MARGIN;
                }
                else {
                    var spaceAtLeftOfTrigger = triggerDimensions.left - MARGIN;
                    if (menuCenterOffset > spaceAtLeftOfTrigger) {
                        left = MARGIN;
                    }
                    else {
                        left = triggerDimensions.left - menuCenterOffset;
                    }
                }
            }
            else {
                var spaceFromLeftOfTrigger = clientWidth - triggerDimensions.left - MARGIN;
                if (menuWidth > spaceFromLeftOfTrigger) {
                    var spaceToRightOfTrigger = triggerDimensions.right - MARGIN;
                    if (menuWidth > spaceToRightOfTrigger) {
                        if (spaceToRightOfTrigger > spaceFromLeftOfTrigger) {
                            left = MARGIN;
                        }
                        else {
                            right = MARGIN;
                        }
                    }
                    else {
                        right = clientWidth - triggerDimensions.right;
                    }
                }
                else {
                    left = triggerDimensions.left;
                }
                if (position === 'vertical-stretched') {
                    minWidth = triggerDimensions.width;
                }
            }
            return { top: top, right: right, bottom: bottom, left: left, minWidth: minWidth };
        }
        default: {
            throw Error('Invalid menu position');
        }
    }
};
//# sourceMappingURL=Menu.utils.js.map